import type { ChangeEvent, Dispatch, FC, SetStateAction } from 'react'
import { CwsGridRow, CwsGridCol, CwsInput, CwsTextarea, CwsLabel } from '@components/cws'
import { useTranslate } from '@hooks/useTranslation'
import { contactFormValidator, EMAIL, MESSAGE, NAME, PHONE } from '@utils/contactFormValidator'

export type MessageKey =
  | 'cart.confirmation.billingName'
  | 'cart.confirmation.vendor.email.label'
  | 'wishlist.share.email.msg'
  | 'cart.confirmation.customerTelephone'

export type FeedbackMessage = {
  [key in MessageKey]: string
}
interface FeedbackProps {
  message: FeedbackMessage
  setMessage: Dispatch<SetStateAction<FeedbackMessage>>
}
export const Feedback: FC<FeedbackProps> = ({ message, setMessage }) => {
  const { translate } = useTranslate()

  const handlerChangeName = (value: string) => {
    setMessage((prevState) => ({ ...prevState, [NAME]: value }))
  }
  const handlerChangeEmail = (value: string) => {
    setMessage((prevState) => ({ ...prevState, [EMAIL]: value }))
  }
  const handlerChangePhone = (value: string) => {
    setMessage((prevState) => ({ ...prevState, [PHONE]: value }))
  }
  const handlerChangeMessage = (value: string) => {
    setMessage((prevState) => ({ ...prevState, [MESSAGE]: value }))
  }

  const allFiled = !Object.values(message).includes('')

  return (
    <CwsGridRow>
      <CwsGridCol col="12">
        <CwsGridRow>
          <CwsGridCol col="12">
            <CwsGridRow>
              <CwsGridCol col="12" lg="6">
                <CwsLabel>{`${translate('cart.confirmation.billingName')}:`}</CwsLabel>
                <CwsInput
                  invalid={
                    allFiled &&
                    !contactFormValidator('cart.confirmation.billingName', message['cart.confirmation.billingName'])
                  }
                  value={message[NAME]}
                  onChange={handlerChangeName}
                />
              </CwsGridCol>
            </CwsGridRow>
          </CwsGridCol>
          <CwsGridCol col="12" lg="6">
            <CwsLabel>{`${translate('cart.confirmation.vendor.email.label')}:`}</CwsLabel>
            <CwsInput
              invalid={
                allFiled &&
                !contactFormValidator(
                  'cart.confirmation.vendor.email.label',
                  message['cart.confirmation.vendor.email.label']
                )
              }
              value={message[EMAIL]}
              onChange={handlerChangeEmail}
            />
          </CwsGridCol>
          <CwsGridCol col="12" lg="6">
            <CwsLabel>{`${translate('cart.confirmation.customerTelephone')}:`}</CwsLabel>
            <CwsInput
              invalid={
                allFiled &&
                !contactFormValidator(
                  'cart.confirmation.customerTelephone',
                  message['cart.confirmation.customerTelephone']
                )
              }
              optional
              value={message[PHONE]}
              helperText={translate('w2.feedback.required')}
              onChange={handlerChangePhone}
            />
          </CwsGridCol>
          <CwsGridCol col="12">
            <CwsLabel>{`${translate('wishlist.share.email.msg')}:`}</CwsLabel>
            <CwsTextarea
              invalid={
                allFiled && !contactFormValidator('wishlist.share.email.msg', message['wishlist.share.email.msg'])
              }
              onChange={handlerChangeMessage}
            />
          </CwsGridCol>
        </CwsGridRow>
      </CwsGridCol>
    </CwsGridRow>
  )
}
